'use client'

import { RefreshCw } from 'lucide-react'
import { Button } from '@/components/ui/button'

type PropsType = {
  label: string
}

const RefreshButton = ({ label }: PropsType) => {
  return (
    <Button size="lg" variant="default" onClick={() => window.location.reload()}>
      <RefreshCw />
      {label}
    </Button>
  )
}

export default RefreshButton
